<template>
  <el-row style="height: 800px;width: 100%;margin-top: 80px;">
    <el-row style="width: 100%;height: 100px;">
      <el-row class="hardware-logo" />
    </el-row>
    <el-row style="width: 64%;margin-left: 18%;height: 620px;margin-top: 80px;">
      <el-col v-for="(data, i) in dataList" :key="i" :style="{width: 'calc(100% / 3)', height: 'calc(100% / 2)'}">
        <el-row v-if="i % 2 === 0" style="width: 100%;height: 100%;">
          <el-row class="hardware-img-box">
            <el-row @click.native="changeRoute('/hardware', data.id)" class="hardware-img" :style="{'background-image': 'url(' + data.img + ')'}"></el-row>
          </el-row>
          <el-row class="hardware-text">{{data.name}}</el-row>
        </el-row>
        <el-row v-else style="width: 100%;height: 100%;">
          <el-row class="hardware-img-box">
            <el-row @click.native="changeRoute('/hardware', data.id)" class="hardware-img" :style="{'background-image': 'url(' + data.img + ')'}"></el-row>
          </el-row>
          <el-row class="hardware-text">{{data.name}}</el-row>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'Software',
  data() {
    return {
      dataList: [
        {id: '321', name: '智能仪表', img: require('../../assets/img/hardware/yk8220.png')},
        {id: '321', name: '保护装置', img: require('../../assets/img/hardware/baohu.png')},
        {id: '323', name: '智能网关', img: require('../../assets/img/hardware/wangguan.png')},
        {id: '322', name: '智能传感', img: require('../../assets/img/hardware/chuangan.png')},
        {id: '321', name: '负荷识别', img: require('../../assets/img/hardware/yk8400.png')},
        // {id: '324', name: '智慧安防', img: require('../../assets/img/hardware/jiankong.png')}
      ]
    }
  },
  methods: {
    changeRoute(path, page) {
      this.$router.push({path: path, query: {page: page}})
    }
  }
}
</script>

<style scoped>
  .hardware-logo {
    background: url("../../assets/hardware.png") no-repeat;
    width: 470px;
    margin-left: calc(50% - 235px);
    height: 100px;
    cursor: pointer;
  }
  .hardware-img-box {
    height: 76%;
    width: 88%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #bbbbbb;
    box-shadow: 10px 10px rgba(0, 0, 0, 0.06);
    margin-left: 6%;
  }
  .hardware-img {
    width: 216px;
    height: 176px;
    cursor: pointer;
    background-repeat: no-repeat
  }
  .hardware-text {
    width: 90%;
    margin: 6% 0 0 5%;
    height: 18%;
    font-size: 22px;
    font-family: "Microsoft YaHei";
    color: #9fa0a0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Hardware.vue